/* Kopstorm W141 live Loox reviews (13 Oct 2026).
   Loads the kit's Loox widget HTML and fills the three review cards with the
   newest 5 star reviews of this kit that have a photo or video thumbnail.
   The server rendered cards stay in place when Loox cannot be read. */
(function () {
  if (window.kop14LooxLoaded) return;
  window.kop14LooxLoaded = true;

  /* Preview only while K_26 runs, so the test variant stays unchanged for
     visitors. Open any kit page with ?kop_loox=1 to see the Loox cards
     (kept for the browser session), ?kop_loox=0 to switch it off again.
     For the rollout after K_26, set PREVIEW_ONLY to false. */
  var PREVIEW_ONLY = true;
  var PREVIEW_KEY = 'kop14-loox-preview';
  try {
    var param = new URLSearchParams(window.location.search).get('kop_loox');
    if (param === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
    if (param === '0') sessionStorage.removeItem(PREVIEW_KEY);
  } catch (e) {}
  var previewOn = false;
  try { previewOn = sessionStorage.getItem(PREVIEW_KEY) === '1'; } catch (e) {}
  if (PREVIEW_ONLY && !previewOn) return;
  /* In preview the review cards show even outside the K_26 variant group. */
  if (previewOn) document.documentElement.classList.add('kop-w141');

  var CACHE_MS = 60 * 60 * 1000;
  var MAX_TEXT = 140;

  function cacheGet(key) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      return Date.now() - data.t < CACHE_MS ? data.r : null;
    } catch (e) { return null; }
  }

  function cacheSet(key, reviews) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), r: reviews })); } catch (e) {}
  }

  function shorten(text) {
    text = text.replace(/\s+/g, ' ').trim();
    if (text.length <= MAX_TEXT) return text;
    var cut = text.slice(0, MAX_TEXT);
    var end = cut.search(/[.!?][^.!?]*$/);
    if (end > 40) return cut.slice(0, end + 1);
    return cut.replace(/\s+\S*$/, '').replace(/[,;:]$/, '') + '...';
  }

  function midImage(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (/_mid\.(jpe?g|png|webp)$/i.test(src)) return src;
    return src.replace(/\.(jpe?g|png|webp)$/i, '_mid.$1');
  }

  function parse(html, title) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var titleLow = (title || '').toLowerCase();
    var own = [];
    var other = [];
    var items = doc.querySelectorAll('[data-id].grid-item-wrap, [data-id].has-img');
    if (!items.length) items = doc.querySelectorAll('.grid-item');
    items.forEach(function (item) {
      var id = item.getAttribute('data-id') || '';
      var img = item.querySelector('[data-testid="review-' + id + '-media"] img') || item.querySelector('img[src*="loox.io"]');
      var textEl = item.querySelector('[data-testid="review-' + id + '-text"]') || item.querySelector('.main-text');
      var nameEl = item.querySelector('[data-testid="review-' + id + '-title"]') || item.querySelector('.title');
      var starsEl = item.querySelector('[data-testid="review-' + id + '-stars"] [aria-label]') || item.querySelector('.stars [aria-label]');
      if (!img || !textEl || !nameEl) return;
      if (starsEl && !/5\s*\/\s*5/.test(starsEl.getAttribute('aria-label') || '')) return;
      var name = (nameEl.firstChild && nameEl.firstChild.nodeType === 3 ? nameEl.firstChild.textContent : nameEl.textContent).trim();
      var text = textEl.textContent.trim();
      if (!name || text.length < 25) return;
      var review = {
        name: name,
        text: shorten(text),
        photo: midImage(img.getAttribute('src')),
        video: (item.getAttribute('data-media-type') || (item.closest && item.closest('[data-media-type]') ? item.closest('[data-media-type]').getAttribute('data-media-type') : '')) === 'video'
      };
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      (titleLow && alt.indexOf(titleLow) > -1 ? own : other).push(review);
    });
    /* Photos of this kit first, then video thumbnails of this kit. Other kits
       are only used when the kit itself has fewer than three. */
    function photoFirst(a, b) { return a.video - b.video; }
    return own.sort(photoFirst).concat(other.sort(photoFirst)).slice(0, 3);
  }

  function render(root, reviews) {
    var track = root.querySelector('[data-kop14-proof-track]');
    var template = track && track.querySelector('.kop14-proof__card');
    if (!template || reviews.length < 3) return;
    var frag = document.createDocumentFragment();
    reviews.forEach(function (review) {
      var card = template.cloneNode(true);
      card.classList.add('kop14-proof__card--loox');
      var img = card.querySelector('.kop14-proof__img');
      if (!img || img.tagName !== 'IMG') {
        img = document.createElement('img');
        img.className = 'kop14-proof__img';
        card.insertBefore(img, card.firstChild);
      }
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = review.photo;
      img.alt = review.name;
      img.width = 112;
      img.height = 112;
      img.loading = 'lazy';
      var text = card.querySelector('.kop14-proof__text');
      if (text) text.textContent = '“' + review.text + '”';
      var name = card.querySelector('.kop14-proof__name > span:first-child');
      if (name) name.textContent = review.name;
      frag.appendChild(card);
    });
    track.replaceChildren(frag);
    track.scrollLeft = 0;
    track.dispatchEvent(new Event('scroll'));
  }

  function load(root) {
    if (root.dataset.kop14LooxReady) return;
    root.dataset.kop14LooxReady = '1';
    var store = root.getAttribute('data-kop14-loox');
    var product = root.getAttribute('data-kop14-loox-product');
    var title = root.getAttribute('data-kop14-loox-title');
    if (!store || !product) return;
    var key = 'kop14-loox-v2-' + product;
    var cached = cacheGet(key);
    if (cached) { render(root, cached); return; }
    var proxy = (root.getAttribute('data-kop14-loox-proxy') || '').replace(/\/+$/, '');
    /* Loox blocks direct reads from the store (CORS), so the worker fetches it. */
    var url = proxy
      ? proxy + '/?product=' + encodeURIComponent(product)
      : 'https://loox.io/widget/' + encodeURIComponent(store) + '/reviews/' + encodeURIComponent(product) +
        '?limit=40&default_tab=automatic&language=en';
    fetch(url, { credentials: 'omit' })
      .then(function (res) { if (!res.ok) throw new Error('loox ' + res.status); return res.text(); })
      .then(function (html) {
        var reviews = parse(html, title);
        if (reviews.length >= 3) cacheSet(key, reviews);
        document.querySelectorAll('[data-kop14-loox-product="' + product + '"]').forEach(function (el) {
          el.dataset.kop14LooxReady = '1';
          render(el, reviews);
        });
      })
      .catch(function () { /* keep the theme cards */ });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-kop14-loox]');
    if (!roots.length) return;
    if (!('IntersectionObserver' in window)) { roots.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { io.unobserve(entry.target); load(entry.target); }
      });
    }, { rootMargin: '600px 0px' });
    roots.forEach(function (root) { io.observe(root); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
